import TicketList from '@/component/ticketList/TicketList';
import ChatThread from '@/component/chatThread/ChatThread';
import DetailTicket from '@/component/chatThread/DetailTicket';
import AddTicket from '@/component/common/layout/addTicket/AddTicket';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import FormManagement from '@/component/formManagement/FormManagement';
import UserManagement from '@/component/system/UserManagement';
import ListTicketKnowledge from '@/component/ticketKnowledge/ListTicketKnowledge';
import NotificationList from '@/component/notification/NotificationList';
import UserProfile from '@/component/userProfile/UserProfile';
import OrganizationProfile from '@/component/system/OrganizationProfile';
import ProjectManagement from '@/component/system/ProjectManagement';
import ProjectUserManagement from '@/component/project/ProjectUserManagement';
import ProjectProfileManagement from '@/component/project/ProjectProfileManagement';
import ProjectCustomerManagement from '@/component/project/ProjectCustomerManagement';
import DetailTicketKnowledge from '@/component/ticketKnowledge/DetailTicketKnowledge';
import DetailTicketPDFKnowledge from '@/component/ticketKnowledge/DetailTicketPDFKnowledge';
import DrilldownAndDetailSearch from '@/component/ticketKnowledge/DrilldownAndDetailSearch';
import ChatThreadKnowledge from '@/component/chatThread/chatKnowledge/ChatThreadKnowledge';
import ProjectSettingIframe from '@/component/system/ProjectSettingIframe';
import { cloneDeep } from 'lodash';
import DetailTicketDraft from '@/component/ticketList/DetailTicketDraft';
import DetailEmailTicket from '@/component/ticketList/emailTicket/DetailEmailTicket';
import { getRecoil } from 'recoil-nexus';
import { panelInitDataAtom } from '@/state/atom/panelAtom';
import ListOrganization from '@/component/rootOrganization/ListOrganization';
import CorporationCustomerManagement from '@/component/project/CorporationCustomerManagement';
import PublicKnowledgeSiteSetting from '@/component/project/PublicKnowledgeSiteSetting';
import SettingChatBot from '@/component/project/SettingChatbot';
import PreviewChatBot from '@/component/publicPages/previewChatBot/PreviewChatBot';
import KnowledgeUploadCsv from '@/component/ticketKnowledge/KnowledgeUploadCsv';
import ProductManagement from '@/component/productManagement/ProductManagement';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import CorporationContractDetail from '@/component/rootOrganization/CorporationContractDetail';
import NormalViewContractDetail from '@/component/project/NormalViewContract/NormalViewContractDetail';
import SettingAI from '@/component/project/SettingAI';
import ChatAI from '@/component/chatAI/ChatAI';
import localStorageUtil from '@/common/utils/localStorageUtil';

let closePanelId = '';

export const onConfirmClosePanel = (argsAll) => {
    closePanel(closePanelId, argsAll);

    // close panel related
    let { panelRelatedData } = getPanelRelated(argsAll.panelList, argsAll.panelData);
    if(!Utils.isEmptyObject(panelRelatedData)) {
        let currentPanelData = argsAll.panelData;
        let currentTabList = currentPanelData.tabList;

        currentTabList.forEach(tab => {
            argsAll.closePanelTab({
                event: null,
                panelType: panelRelatedData.type,
                panelId: panelRelatedData.id,
                tabId: tab.id
            });
        });
    }
}

export const isPanelEdited = allTabInitData => {
    if (Utils.isEmptyObject(allTabInitData)) {
        return false;
    }

    let isEdited = false;
    for (const tabData of allTabInitData.tabList) {
        if (tabData.data?.isEditedData) {
            isEdited = true;
            break;
        }
    }

    return isEdited;
};

export const onClickClosePanel = (id, argsAll) => {
    if (!id || Utils.isEmptyArray(argsAll.panelList)) {
        return;
    }
    closePanelId = id;
    if (
        [
            Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
            Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
        ].includes(argsAll.panelData.type)
    ) {
        if (
            [
                Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_START,
                Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE
            ].includes(argsAll.handleStatus)
        ) {
            argsAll.setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_PAUSE);
            argsAll.setIsOpenClosePanelCsv(true);
            return;
        }

        let infoTabCsv = argsAll.panelList.find(
            p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
        );

        if(!Utils.isEmptyObject(infoTabCsv)) {
            const panelInitData = argsAll.panelInitData;
            let tabCsvInitData = getAllTabPanelInitData(infoTabCsv.id, panelInitData);
            let isEdited = isPanelEdited(tabCsvInitData);
            if (isEdited) {
                argsAll.setIsOpenConfirmClosePanel(true);
                return;
            }
        }
    }
    if (
        [
            Constant.PANEL_TYPE.ADD_TICKET,
            Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL,
            Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
            Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
            Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
            Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV,
            Constant.PANEL_TYPE.PRODUCT_MANAGEMENT,
            // Constant.PANEL_TYPE.SYSTEM_MANAGEMENT
        ].includes(argsAll.panelData.type)
    ) {
        const panelInitData = argsAll.panelInitData;
        let allTabInitData = getAllTabPanelInitData(id, panelInitData);
        let isEdited = isPanelEdited(allTabInitData);

        // if (argsAll.panelData.type === Constant.PANEL_TYPE.SYSTEM_MANAGEMENT && isEdited) {
        //     argsAll.setIsClosePanelCorp({
        //         isClose: true,
        //         componentType: ''
        //     });
        //     return;
        // }

        if (argsAll.panelData.type === Constant.PANEL_TYPE.PRODUCT_MANAGEMENT && isEdited) {
            argsAll.setIsClosePanelProduct({
                isClose: true
            })

            if (argsAll.panelData.tabList[0].componentType === ProductManagementConstant.EDITION_LIST) {
                argsAll.setIsClosePanelProduct({
                    isClose: true,
                    componentType: ''
                })
            }
            
            return;
        }

        if (isEdited) {
            argsAll.setIsOpenConfirmClosePanel(true);
            return;
        } else {
            closePanel(id, argsAll);
        }
    } else {
        closePanel(id, argsAll);
    }
    // close panel related
    let { panelRelatedData } = getPanelRelated(argsAll.panelList, argsAll.panelData);
    if(!Utils.isEmptyObject(panelRelatedData)) {
        let currentPanelData = argsAll.panelData;
        let currentTabList = currentPanelData.tabList;
 
        currentTabList.forEach(tab => {
            argsAll.closePanelTab({
                event: null,
                panelType: panelRelatedData.type,
                panelId: panelRelatedData.id,
                tabId: tab.id
            });
        });
    }
};

export const closePanel = (id, argsAll) => {
    // Close panel drilldown when close panel list ticket knowledge
    let panelDrillDownId = '';
    let currentPanelIndex = Utils.findIndexInArrayById(id, argsAll.panelList);
    let currentPanelData = argsAll.panelList[currentPanelIndex];

    

    let newPanelListClone = cloneDeep(argsAll.panelList);
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);
    const closePanelIndex = newPanelListClone.findIndex(panel => panel.id === id);

    let isCloseLastPanel = currentPanelIndex === newPanelListClone.length - 1;



    if (
        !Utils.isEmptyObject(currentPanelData) &&
        [
            Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST,
            Constant.PANEL_TYPE.HELPDESK_TICKET_LIST,
        ].includes(currentPanelData.type)
    ) {
        let panelDrillDownType;

        switch (currentPanelData.type) {
            case Constant.PANEL_TYPE.HELPDESK_TICKET_LIST:
                panelDrillDownType = Constant.PANEL_TYPE.HELPDESK_TICKET_LIST_DRILLDOWN_AND_DETAIL_SEARCH;
                break;
            case Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST:
                panelDrillDownType = Constant.PANEL_TYPE.KNOWLEDGE_PRJ_INUSE_DRILLDOWN_AND_DETAIL_SEARCH;
                argsAll.setAtomKnowledgeViewSelected({});
                break;
            case Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST:
                panelDrillDownType = Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_DRILLDOWN_AND_DETAIL_SEARCH;
                break;
        
            default:
                break;
        }
        
        let panelDrillDownData = argsAll.panelList.find(
            (panel) => panel.type === panelDrillDownType
        );
        if (!Utils.isEmptyObject(panelDrillDownData)) {
            panelDrillDownId = panelDrillDownData.id;
        }
    }

    let newPanelList = cloneDeep(argsAll.panelList);

    if(currentPanelData.type !== Constant.PANEL_TYPE.OPEN_CHAT_AI) {
        newPanelList = newPanelList.filter((i) => (i.id !== id && i.id !== panelDrillDownId));
    } else {
        newPanelList[currentPanelIndex].isDisplay = false;
    }

    // panel list after close
    if(currentPanelData.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV) {
        let openPanelIndex = newPanelList.findIndex((panel) => panel.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL);
        if (openPanelIndex === -1) return;
        let tabList = newPanelList[openPanelIndex].tabList;
        let openChatIndex = tabList.findIndex(tab => tab.id ===  currentPanelData?.tabList[0]?.id);
        if (openChatIndex === -1) return;
        argsAll.setIsClosePanelCsvAtom(prev => !prev);
        newPanelList[openPanelIndex].tabList[openChatIndex].component.props.reloadAfterCloseCSv = Date.now().toString();
    }


    // Close upload csv panel when close create ticket panel
    if (
        argsAll?.panelData?.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL
    ) {
        newPanelList = newPanelList.filter(panel => panel?.type !== Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV)
    }
    
    argsAll.setPanelListRecoilState(newPanelList);


    let newIndex = caculateInexClosePanel(isCloseLastPanel, newPanelList, currentPanelData, closePanelIndex, argsAll.currentIndex);
    
    if (newIndex !== argsAll.currentIndex) argsAll.setCurrentIndex(newIndex);

    // update setting
    let newSetting = { ...argsAll.settingSlide };
    newSetting.startIndex = newIndex;
    argsAll.setSettingSlide(newSetting);
    // updateTabListAfterChange();

    // reset masterKnowledgeHyperLink
    let masterKnowledgeHyperLink = {
        isReload: false,

        type: '',
        visibilitySettingType: '',
        isCustomer: true,
        customerId: '',
        projectSelectedId: '',
        corporationSelectedId: '',
        ticketIdItemList: [],
        // link with master knowledge
        masterKnowledgeHyperLink: true
    };
    argsAll.setMasterKnowledgeHyperLink(masterKnowledgeHyperLink);

    if (
        [
            Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV,
            Constant.PANEL_TYPE.KNOWLEDGE_CREATE_TICKET,
            Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL
        ].includes(currentPanelData.type)
    ) {
        argsAll.setHandleStatus(Constant.UPLOAD_CSV_KNOWLEDGE.STATUS_INITIAL);
    }

    removePanelInitData(id, null, argsAll.panelInitData, argsAll.setPanelInitData);
};


const caculateInexClosePanel = (isCloseLastPanel, newPanelList, closePanelData, closePanelIndex, currentAtomPanelndex) => {
    let startPanelIndex = 0;
    let newPanelListClone = cloneDeep(newPanelList);
    newPanelListClone = newPanelListClone.filter(panel => panel?.isDisplay);

    const windowScreenWidth = window.screen.width;
    // for mobile
    if (windowScreenWidth < Constant.PANEL_RESPONSIVE.MOBILE) {
        if (currentAtomPanelndex <= 1 || newPanelListClone.length <= 1) {
            return startPanelIndex;
        }
        return currentAtomPanelndex - 1;
    }

    // for tablet
    if (windowScreenWidth >= Constant.PANEL_RESPONSIVE.MOBILE && windowScreenWidth < Constant.PANEL_RESPONSIVE.PC) {
        if (currentAtomPanelndex <= 1 || newPanelListClone.length <= 2) {
            return startPanelIndex;
        }

        return currentAtomPanelndex - 1; 
    }
    
    // for pc
    if (newPanelListClone.length <= 1) {
        return startPanelIndex;
    }
     
    const lastPanelIndex = newPanelListClone.length - 1;
    let lastPanel = newPanelListClone[lastPanelIndex];
    let lastPanelSize = lastPanel?.size;

    // close last panel => caculate screen view
    if (isCloseLastPanel || currentAtomPanelndex === lastPanelIndex) {
        let prev2Panel = newPanelListClone[lastPanelIndex - 1];
        let prev2PanelSize = prev2Panel?.size;

        let prev3Panel = newPanelListClone[lastPanelIndex - 2];
        let prev3PanelSize = prev3Panel?.size;
        if (lastPanelSize === Constant.PANEL_SIZE.SIZE_2) {
            if (prev2PanelSize === Constant.PANEL_SIZE.SIZE_1) {
                return lastPanelIndex - 1;
            }
        } 

        if (lastPanelSize === Constant.PANEL_SIZE.SIZE_1) {
            if (prev2PanelSize === Constant.PANEL_SIZE.SIZE_1) {
                if (prev3PanelSize === Constant.PANEL_SIZE.SIZE_1) {
                    return lastPanelIndex - 2;
                }
                return lastPanelIndex - 1;
            }

            if (prev2PanelSize === Constant.PANEL_SIZE.SIZE_2) {
                return lastPanelIndex - 1;
            }
        }

        return lastPanelIndex;
    }

    // special case
    if (currentAtomPanelndex === lastPanelIndex - 1) {
        let currentAtomPanel = newPanelListClone[currentAtomPanelndex];
        let currentAtomPanelSize = currentAtomPanel?.size;
        let preCurrentPanelSize = newPanelListClone[currentAtomPanelndex - 1]?.size;
        if (currentAtomPanelSize  === Constant.PANEL_SIZE.SIZE_1 && 
            lastPanelSize === Constant.PANEL_SIZE.SIZE_1 && 
            closePanelData?.size === Constant.PANEL_SIZE.SIZE_1 &&
            preCurrentPanelSize === Constant.PANEL_SIZE.SIZE_1) {
                return currentAtomPanelndex - 1;
        }
    }

  


    // close panel in screen view => max 2 panel exist
    // let focusPanel = newPanelListClone[currentAtomPanelndex];
    // let focusPanelSize = focusPanel?.size;

    // let prePanel = newPanelListClone[currentAtomPanelndex -1];
    // let prePanelSize = prePanel?.size;

    // let pre2PanelSize = newPanelListClone[currentAtomPanelndex - 2]?.size;

    // let nextPanel = newPanelListClone[currentAtomPanelndex + 1];
    // let nextPanelSize = nextPanel?.size;

    // let next2Panel = newPanelListClone[currentAtomPanelndex + 2];
    // let next2PanelSize = next2Panel?.size;
    

    // console.log('namnhdebug caculateInexClosePanel', {isCloseLastPanel, focusPanelSize, nextPanelSize, prePanelSize, pre2PanelSize})

    // view 2
    // if (focusPanelSize === Constant.PANEL_SIZE.SIZE_2) {
    //     if (prePanelSize) {
    //         // view 1-2
    //         if (prePanelSize === Constant.PANEL_SIZE.SIZE_1) {
    //             return currentAtomPanelndex - 1;
    //         }
    //     }
    // }
    // // view 1
    // if (focusPanelSize === Constant.PANEL_SIZE.SIZE_1) {
    //     // check pre before
    //     if (prePanelSize) {
    //         // view 2-1
    //         if (prePanelSize === Constant.PANEL_SIZE.SIZE_2) {
    //             return currentAtomPanelndex - 1;
    //         }
    //         // view 1-1
    //         if (prePanelSize === Constant.PANEL_SIZE.SIZE_1) {
    //             // view 1-1-1
    //             if (pre2PanelSize === Constant.PANEL_SIZE.SIZE_1) {
    //                 return currentAtomPanelndex - 2;
    //             }
    //             return currentAtomPanelndex - 1;
    //         }
    //     }

    //     // view 1-1
    //     if (nextPanelSize  === Constant.PANEL_SIZE.SIZE_1) {
    //         // view 1-1-1 => default
    //         // view 1-1-2 => focus to panel size 2
    //         if (next2PanelSize  === Constant.PANEL_SIZE.SIZE_2) {
    //             return currentAtomPanelndex + 1;
    //         }

    //         // view 1-1-3 => focus to panel size 3
    //         if (next2PanelSize  === Constant.PANEL_SIZE.SIZE_3) {
    //             return currentAtomPanelndex + 2;
    //         }
    //     }

    //     if (nextPanelSize === Constant.PANEL_SIZE.SIZE_3) {
    //         return currentAtomPanelndex + 1;
    //     }
    // }


    return currentAtomPanelndex;
}

const prepapreComponentToAddPanel = (
    props,
    projectDetail,
    userDetail,
    type,
    panelId,
    tabId,
    ticketId,
    ticketOutline,
    isTicketDeleted,
    selectThreadId,
    ticketListType,
    data,
    selectedTicketType,
    isDraft,
    isEmailTicket,
    visibilitySettingType,
    isOpenFromChatAI,
    filterKnowledgeListData,
    knowledgeAffiliationOrganization,
    knowledgeAffiliationProject,
    isDuplicate,
    isViewByList,
    orgId,
    orgName,
    tabNameChatAI,
) => {
    let component

    const componentProps = {...props}
    delete componentProps.corporationDetail
    delete componentProps.projectDetail
    delete componentProps.userDetail
    delete componentProps.panelListRecoilState
    delete componentProps.panelList

    switch (type) {
        case Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST:
        case Constant.PANEL_TYPE.HELPDESK_TICKET_LIST:
            component = {
                id: panelId,
                type: `${ticketListType}_ticket_list`,
                tabList: [
                    {
                        id: tabId,
                        component: (
                            <TicketList
                                {...componentProps}
                                componentName={'TicketList'}
                                panelId={panelId}
                                panelType={type}
                                ticketListType={ticketListType}
                                // ticketListTab={ticketListTab}
                            />
                        )
                    }
                ],
                activeTab: 0
            };
            break;
        case Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD:
        case Constant.PANEL_TYPE.HELPDESK_CHATTHREAD:
            {
                if (!ticketId) {
                    break;
                }
    
                const propsClone = {
                    ...componentProps,
                    ...(!Utils.isEmptyString(selectThreadId) && { selectThreadId: selectThreadId })
                }
                component = {
                    id: panelId,
                    type: type,
                    tabList: [
                        {
                            id: tabId,
                            component: (
                                <ChatThread
                                    {...propsClone}
                                    componentName={'ChatThread'}
                                    panelId={panelId}
                                    tabId={tabId}
                                    ticketId={ticketId}
                                    panelType={type}
                                    selectThreadId={data.selectThreadId}
                                    isShowAllChatPost={data.isShowAllChatPost}
                                />
                            ),
                            ticketOutline: ticketOutline,
                            isTicketDeleted
                        }
                    ],
                    activeTab: 0
                };
                break;
            }
        case Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD:
            {
                if (!ticketId) {
                    break;
                }
                const knowledgePropsClone = {
                    ...componentProps,
                    ...(!Utils.isEmptyString(selectThreadId) && { selectThreadId: selectThreadId })
                }
                component = {
                    id: panelId,
                    type: type,
                    tabList: [
                        {
                            id: tabId,
                            component: (
                                <ChatThreadKnowledge
                                    {...knowledgePropsClone}
                                    componentName={'ChatThreadKnowledge'}
                                    panelId={panelId}
                                    ticketId={ticketId}
                                    panelType={type}
                                    selectThreadId={data.selectThreadId}
                                    tabId ={tabId}
                                />
                            ),
                            ticketOutline: ticketOutline,
                            isTicketDeleted: isTicketDeleted
                        }
                    ],
                    activeTab: 0
                };
                break;
            }
        case Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL:
        case Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL:
            {
                let ticketDetailComponent;
                if (tabId.includes('NEW_TICKET')) {
                    ticketDetailComponent = (
                        <AddTicket
                            {...componentProps}
                            componentName="AddTicket"
                            panelId={panelId}
                            panelType={type}
                            tabId={tabId}
                            ticketId={ticketId}
                            selectedTicketType={selectedTicketType}
                        />
                    );
                } else if (isDraft) {
                    ticketDetailComponent = (
                        <DetailTicketDraft
                            {...componentProps}
                            componentName={Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT}
                            panelId={panelId}
                            ticketId={ticketId}
                            tabId={tabId}
                            isDraft={isDraft}
                        />
                    );
                } else if (isEmailTicket) {
                    ticketDetailComponent = (
                        <DetailEmailTicket
                            {...componentProps}
                            componentName={Constant.COMPONENT_NAME.DETAIL_TICKET_EMAIL}
                            panelId={panelId}
                            ticketId={ticketId}
                            tabId={tabId}
                            isDraft={false}
                            isEmailTicket={isEmailTicket}
                        />
                    );
                } else {
                    ticketDetailComponent = (
                        <DetailTicket
                            {...componentProps}
                            componentName="DetailTicket"
                            panelId={panelId}
                            ticketId={ticketId}
                            tabId={tabId}
                            isDraft={false}
                            isOpenChat={data.isOpenChat}
                        />
                    );
                }

                component = {
                    id: panelId,
                    type: type,
                    tabList: [
                        {
                            id: tabId,
                            component: ticketDetailComponent,
                            ticketOutline: props?.ticketInfo?.outline || (ticketOutline || ''),
                            isDraft: isDraft,
                            isTicketDeleted: isTicketDeleted || false
                        }
                    ],
                    activeTab: 0
                };
                break;

            }
        case Constant.PANEL_TYPE.SYSTEM_MANAGEMENT:
            {
                let systemComponent;
                switch (tabId) {
                    case Constant.PANEL_TYPE.SYSTEM_USER_MANAGEMENT:
                        systemComponent = (
                            <UserManagement
                                componentName={'UserManagement'}
                                {...componentProps}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                        break;
                    case Constant.PANEL_TYPE.SYSTEM_ORG_PROFILE:
                        systemComponent = (
                            <OrganizationProfile
                                componentName={'OrganizationProfile'}
                                {...componentProps}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                        break;
                    case Constant.PANEL_TYPE.SYSTEM_PROJECT_MANAGEMENT:
                        systemComponent = (
                            <ProjectManagement
                                componentName={'ProjectManagement'}
                                {...componentProps}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                        break;
                    case Constant.PANEL_TYPE.SYSTEM_CORPORATION_CUSTOMER_MANAGEMENT:
                        systemComponent = (
                            <CorporationCustomerManagement
                                componentName={'CorporationCustomerManagement'}
                                {...componentProps}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                        break;
                    case Constant.PANEL_TYPE.SYSTEM_NORMAL_CONTRACT_DETAIL:
                        systemComponent = (
                            <NormalViewContractDetail
                                {...componentProps}
                                componentName={Constant.COMPONENT_NAME.NORMAL_VIEW_CONTRACT_DETAIL}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                        break; 
                    default:
                        break;
                }
                let projectName = !Utils.isEmptyObject(projectDetail) ? projectDetail.name : '';
    
                component = {
                    id: panelId,
                    type: Constant.PANEL_TYPE.SYSTEM_MANAGEMENT,
                    tabList: [
                        {
                            id: tabId,
                            component: systemComponent,
                            projectName: projectName
                        }
                    ],
                    activeTab: 0
                };
                break;
            }
        case Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST:
            component = {
                id: panelId,
                type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
                tabList: [
                    {
                        id: tabId,
                        component: (
                            <ListTicketKnowledge
                                componentName={'ListTicketKnowledge'}
                                {...componentProps}
                                panelId={panelId}
                                visibilitySettingType={visibilitySettingType}
                                projectSelectedId={data.projectSelectedId}
                                corporationSelectedId={data.corporationSelectedId}
                                knowledgeInfoChatAi={data.knowledgeInfoChatAi}
                                isCustomer={data.isCustomer}
                                customerId={data.customerId}
                                ticketIdList={data.ticketIdItemList}
                                masterKnowledgeHyperLink={data.masterKnowledgeHyperLink}
                                isOpenFromChatAI={isOpenFromChatAI}
                                filterKnowledgeListData={filterKnowledgeListData}
                            />
                        )
                    }
                ],
                activeTab: 0
            };
            break;
        case Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST:
            component = {
                id: panelId,
                type: Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST,
                tabList: [
                    {
                        id: tabId,
                        component: (
                            <ListTicketKnowledge
                                {...componentProps}
                                componentName={'ListTicketKnowledge'}
                                panelId={panelId}
                                visibilitySettingType={visibilitySettingType}
                                projectSelectedId={data.projectSelectedId}
                                corporationSelectedId={data.corporationSelectedId}
                                isCustomer={data.isCustomer}
                                customerId={data.customerId}
                            />
                        )
                    }
                ],
                activeTab: 0
            };
            break;
        case Constant.PANEL_TYPE.KNOWLEDGE_PRJ_INUSE_DRILLDOWN_AND_DETAIL_SEARCH:
        case Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_DRILLDOWN_AND_DETAIL_SEARCH:
        case Constant.PANEL_TYPE.HELPDESK_TICKET_LIST_DRILLDOWN_AND_DETAIL_SEARCH:
            {
                let parentPanel = Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST;
                if (type === Constant.PANEL_TYPE.HELPDESK_TICKET_LIST_DRILLDOWN_AND_DETAIL_SEARCH) {
                    parentPanel = Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
                }
                component = {
                    id: panelId,
                    type: type,
                    tabList: [
                        {
                            id: tabId,
                            component: (
                                <DrilldownAndDetailSearch
                                    componentName={'DrilldownAndDetailSearch'}
                                    {...componentProps}
                                    panelId={panelId}
                                    corporationId={knowledgeAffiliationOrganization}
                                    projectId={knowledgeAffiliationProject}
                                    userId={userDetail.id}
                                    isCustomer={data.isCustomer}
                                    parentPanel={parentPanel}
                                />
                            ),
                            corporationId: knowledgeAffiliationOrganization,
                            projectId: knowledgeAffiliationProject,
                            userId: userDetail.id,
                            isCustomer: data.isCustomer,
                            parentPanel: parentPanel
                        }
                    ],
                    activeTab: 0
                };
                break;
            }
        case Constant.PANEL_TYPE.LIST_NOTIFICATION:
            component = {
                id: panelId,
                type: Constant.PANEL_TYPE.LIST_NOTIFICATION,
                tabList: [
                    {
                        id: tabId,
                        component: (
                            <NotificationList
                                componentName={'NotificationList'}
                                {...componentProps}
                                panelId={panelId}
                            />
                        )
                    }
                ],
                activeTab: 0
            };
            break;
        case Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL:
        case Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_DETAIL:
            {
                let knowledgeTicketDetailComponent;
                if (tabId.includes(Constant.PANEL_TYPE.KNOWLEDGE_CREATE_TICKET)) {
                    knowledgeTicketDetailComponent = (
                        <AddTicket
                            {...componentProps}
                            componentName="AddTicket"
                            panelId={panelId}
                            panelType={type}
                            tabId={tabId}
                        />
                    );
                } else if (data?.isPDFKnowledge) {
                    knowledgeTicketDetailComponent = (
                        <DetailTicketPDFKnowledge
                            {...componentProps}
                            componentName="DetailTicketPdfKnowledge"
                            panelId={panelId}
                            ticketId={ticketId}
                            panelType={type}
                            tabId={tabId}
                            isCustomer={data.isCustomer}
                        />
                    );
                } else {
                    knowledgeTicketDetailComponent = (
                        <DetailTicketKnowledge
                            {...componentProps}
                            componentName="DetailTicketKnowledge"
                            panelId={panelId}
                            ticketId={ticketId}
                            panelType={type}
                            tabId={tabId}
                            isCustomer={data.isCustomer}
                        />
                    );
                }

                // Ghi đè nếu là draft
                if (isDraft) {
                    knowledgeTicketDetailComponent = (
                        <DetailTicketDraft
                            componentName={Constant.COMPONENT_NAME.DETAIL_TICKET_DRAFT}
                            API={props?.API}
                            panelId={panelId}
                            ticketId={ticketId}
                            panelType={type}
                            ticketOutline={ticketOutline}
                            tabId={tabId}
                            isDraft={true}
                            isDuplicate={isDuplicate}
                        />
                    );
                }

                // Tách xử lý outline
                let outline = props?.ticketInfo?.outline || '';
                if (Utils.isEmptyString(outline) && !Utils.isEmptyString(ticketOutline)) {
                    outline = ticketOutline;
                }

                // Build final component
                component = {
                    id: panelId,
                    type: type,
                    tabList: [
                        {
                            id: tabId,
                            component: knowledgeTicketDetailComponent,
                            ticketOutline: outline,
                            isTicketDeleted: isTicketDeleted,
                            isViewByList: isViewByList
                        }
                    ],
                    activeTab: 0
                };
                break;
            }
        case Constant.PANEL_TYPE.PROJECT_MANAGEMENT:
            {
                let systemComponents;
                switch (tabId) {  
                    case Constant.PANEL_TYPE.SYSTEM_PROJECT_PROFILE_MANAGEMENT:
                        systemComponents = (
                            <ProjectProfileManagement
                                {...componentProps}
                                componentName={Constant.COMPONENT_NAME.PROJECT_PROFILE_MANAGEMENT}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                        break;          
                    case Constant.PANEL_TYPE.SYSTEM_PROJECT_USER_MANAGEMENT:
                        systemComponents = (
                            <ProjectUserManagement
                                componentName={'ProjectUserManagement'}
                                {...componentProps}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                        break;
                    case Constant.PANEL_TYPE.SYSTEM_PROJECT_CUSTOMER_MANAGEMENT:
                        systemComponents = (
                            <ProjectCustomerManagement
                                componentName={'ProjectCustomerManagement'}
                                {...componentProps}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                        break;
                    case Constant.PANEL_TYPE.SYSTEM_PUBLIC_KNOWLEDGE_SITE_SETTING:
                        systemComponents = (
                            <PublicKnowledgeSiteSetting
                                componentName={'PublicKnowledgeSiteSetting'}
                                {...componentProps}
                                panelType={type}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                        break;
                        case Constant.PANEL_TYPE.SYSTEM_PROJECT_SETTING_CHATBOT:
                            systemComponents = (
                                <SettingChatBot
                                    componentName={'SettingChatbot'}
                                    {...componentProps}
                                    panelId={panelId}
                                    panelType={type}
                                    tabId={tabId}
                                />
                            );
                            break;
                        case Constant.PANEL_TYPE.SYSTEM_PROJECT_SETTING_AI:
                            systemComponents = (
                                <SettingAI
                                    componentName={Constant.COMPONENT_NAME.SETTING_AI}
                                    {...componentProps}
                                    panelId={panelId}
                                    panelType={type}
                                    tabId={tabId}
                                />
                            );
                            break;
                        case Constant.PANEL_TYPE.PREVIEW_CHATBOT:
                            systemComponents = (
                                <PreviewChatBot
                                    componentName={Constant.COMPONENT_NAME.PREVIEW_CHATBOT}
                                    {...componentProps}
                                    panelId={panelId}
                                    panelType={type}
                                    tabId={tabId}
                                />)
                            break;
                    default:
                        break;
                }
                let projectNames = !Utils.isEmptyObject(projectDetail) ? projectDetail.name : '';
                if (tabId.startsWith(Constant.PANEL_TYPE.SYSTEM_PROJECT_SETTING_IFRAME)) {
                    systemComponents = (
                        <ProjectSettingIframe
                            {...componentProps}
                            componentName={Constant.COMPONENT_NAME.PROJECT_SETTING_IFRAME}
                            panelId={panelId}
                            projectId={projectDetail.id}
                            panelType={type}
                            tabId={tabId}
                        />
                    );
                }
                
                component = {
                    id: panelId,
                    type: Constant.PANEL_TYPE.PROJECT_MANAGEMENT,
                    tabList: [
                        {
                            id: tabId,
                            component: systemComponents,
                            projectName: projectNames
                        }
                    ],
                    activeTab: 0
                };
                break;
            }
        case Constant.PANEL_TYPE.FORMAT_MANAGEMENT:
            {
                let formComponents;
                if (tabId === Constant.PANEL_TYPE.SYSTEM_FIELD_MANAGEMENT) {
                    formComponents = (
                        <FormManagement
                            componentName={'FormManagement'}
                            {...componentProps}
                            panelId={panelId}
                            tabId={tabId}
                        />
                    );
                }

                let projectFormName = !Utils.isEmptyObject(projectDetail) ? projectDetail.name : '';
                component = {
                    id: panelId,
                    type: Constant.PANEL_TYPE.FORMAT_MANAGEMENT,
                    tabList: [
                        {
                            id: tabId,
                            component: formComponents,
                            projectName: projectFormName
                        }
                    ],
                    activeTab: 0
                };
                break;
            }
        case Constant.PANEL_TYPE.PERSONAL_MANAGEMENT:
            {
                let personalComponent;
                if (tabId === Constant.PANEL_TYPE.SYSTEM_USER_PROFILE) {
                    personalComponent = (
                            <UserProfile
                                {...componentProps}
                                componentName={'UserProfile'}
                                panelId={panelId}
                                tabId={tabId}
                            />
                        );
                }
                let personalName = !Utils.isEmptyObject(projectDetail) ? projectDetail.name : '';
                component = {
                    id: panelId,
                    type: Constant.PANEL_TYPE.PERSONAL_MANAGEMENT,
                    tabList: [
                        {
                            id: tabId,
                            component: personalComponent,
                            projectName: personalName
                        }
                    ],
                    activeTab: 0
                };
                break;
            }
        case Constant.PANEL_TYPE.ROOT_LIST_ORG:
            component = {
                id: panelId,
                type: type,
                tabList: [
                    {
                        id: tabId,
                        component: (
                            <ListOrganization
                                {...componentProps}
                                componentName={'RootListOrg'}
                                panelId={panelId}
                                panelType={type}
                                ticketListType={ticketListType}
                                // ticketListTab={ticketListTab}
                            />
                        )
                    }
                ],
                activeTab: 0
            };
            break;
        case Constant.PANEL_TYPE.PRODUCT_MANAGEMENT:
            component = {
                id: panelId,
                type: type,
                tabList: [
                    {
                        id: tabId,
                        component: (
                            <ProductManagement
                                {...componentProps}
                                componentName={Constant.PANEL_TYPE.PRODUCT_MANAGEMENT}
                                panelId={panelId}
                                panelType={type}
                                ticketListType={ticketListType}
                                tabId={tabId}
                            />
                        )
                    }
                ],
                activeTab: 0
            };
            break;
        case Constant.PANEL_TYPE.ROOT_ORG_EDIT_CONTRACT:
            if (!orgId) {
                break;
            }
            component = {
                id: panelId,
                type: type,
                tabList: [
                    {
                        id: tabId,
                        component: (
                            <CorporationContractDetail 
                                {...componentProps}
                                componentName={'editOrgContract'}
                                panelId={panelId}
                                orgId={orgId}
                                panelType={type}
                                orgName={orgName}
                                tabId={tabId}
                            />
                        ),
                        orgName: orgName,
                        orgId:orgId
                    }
                ],
                activeTab: 0
            };
            break;
        case Constant.PANEL_TYPE.PREVIEW_CHATBOT:
            component = {
                id: panelId,
                type: type,
                tabList: [
                    {
                        id: tabId,
                        component: (
                            <PreviewChatBot
                                {...componentProps}
                                componentName={Constant.COMPONENT_NAME.PREVIEW_CHATBOT}
                                panelId={panelId}
                                panelType={type}
                            />
                        )
                    }
                ],
                activeTab: 0
            };
            break;
        case Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV:
            component = {
                id: panelId,
                type: type,
                tabList: [
                    {
                        id: tabId,
                        component: (
                            <KnowledgeUploadCsv
                                {...componentProps}
                                componentName={'knowledgeUploadCsv'}
                                panelId={panelId}
                                panelType={type}
                                tabId={tabId}
                            />
                        )
                    }
                ],
                activeTab: 0
            };
            break;
        case Constant.PANEL_TYPE.OPEN_CHAT_AI:
            {
                let openChatAIComponent = (
                    <ChatAI
                        {...componentProps}
                        componentName={Constant.COMPONENT_NAME.OPEN_CHAT_AI}
                        panelId={panelId}
                        panelType={type}
                        tabId={tabId}
                        filterKnowledgeListData={filterKnowledgeListData}
                        tabNameChatAI={tabNameChatAI}
                    />
                );
                component = {
                    id: panelId,
                    type: type,
                    tabList: [
                        {
                            id: tabId,
                            component: openChatAIComponent,
                        }
                    ],
                    activeTab: 0
                };
                break;
            }
        default:
            break;
    }

    return component;
}

// add new and update userWorkspace need update WrapPanelHandler.js function initWorkspacePanel
export const addPanel = (data) => {
    const {
        type,
        tabId,
        props,
        ticketId,
        userDetail,
        ticketOutline,
        ticketListType,
        isAddNewTab,
        openPanelId,
        visibilitySettingType,
        knowledgeAffiliationOrganization,
        knowledgeAffiliationProject,
        projectDetail,
        isDraft,
        isEmailTicket,
        orgId,
        orgName,
        newPanelId,
        isTicketDeleted,
        isViewByList,
        isOpenFromChatAI,
        filterKnowledgeListData,
        selectedTicketType,
        tabNameChatAI,
        isDuplicate,
        selectThreadId
    } = data;

    let panelId = isAddNewTab
        ? openPanelId
        : (newPanelId || Date.now().toString());

    let component = prepapreComponentToAddPanel(
        props,
        projectDetail,
        userDetail,
        type,
        panelId,
        tabId,
        ticketId,
        ticketOutline,
        isTicketDeleted,
        selectThreadId,
        ticketListType,
        data,
        selectedTicketType,
        isDraft,
        isEmailTicket,
        visibilitySettingType,
        isOpenFromChatAI,
        filterKnowledgeListData,
        knowledgeAffiliationOrganization,
        knowledgeAffiliationProject,
        isDuplicate,
        isViewByList,
        orgId,
        orgName,
        tabNameChatAI,
    );

    if (component){
        component.isDisplay = true;
    }

    // mapping panel size
    const defaultPanelSize = [Constant.PANEL_TYPE.SYSTEM_MANAGEMENT, Constant.PANEL_TYPE.PROJECT_MANAGEMENT].includes(component.type)
        ? Constant.PANEL_SIZE.SIZE_3
        : Constant.PANEL_SIZE.SIZE_1;

    const selectedProjectId = localStorageUtil.getSelectedProjectId();
    const userSetting = Utils.convertJSONDataToObject(userDetail?.userSetting);
    const panelSizeSetting = userSetting?.panelSizeSetting || {};
    const currentSettingPanelSize = panelSizeSetting[selectedProjectId] || [];

    let addNewPanel;

    if (!Utils.isEmptyArray(currentSettingPanelSize)) {
        const currentPanel = currentSettingPanelSize.find(panel => panel.type === component.type);

        addNewPanel = {
            ...component,
            size: currentPanel ? currentPanel.size : defaultPanelSize,
            projectInuseId: selectedProjectId
        };
    } else {
        addNewPanel = {
            ...component,
            size: defaultPanelSize,
            projectInuseId: selectedProjectId
        };
    }

    return addNewPanel;
};


export const updateTabListBeforeChange = () => {
    document.querySelectorAll('.panelTabList .tabListContainer').forEach(el => {
        el.classList.add("hide-scrolling");
    });
}


export const updateTabListAfterChange = () => {
    document.querySelectorAll('.panelTabList .tabListContainer').forEach(el => {
        el.classList.remove("hide-scrolling");
    });
}

export const getVisibleWidth = (elements, panelData) => {
    const container = document.getElementById(`panel-list-${panelData.id}`);
    let containerRect = container.getBoundingClientRect();
    let eleRect = elements.getBoundingClientRect();
    let rect = {};
    rect.top = eleRect.top - containerRect.top;
    rect.right = eleRect.right - containerRect.right;
    rect.bottom = eleRect.bottom - containerRect.bottom;
    rect.left = eleRect.left - containerRect.left;
    rect.width = eleRect.width;
    return rect;
}

export const onClickCloseTab = (event, panelData, tab, setCloseTabIdState, closePanelTab, argsAll, setIsConfirmDeleteTabChat) => {
    const indexNeedCloseTab = Utils.findIndexInArrayById(tab.id, panelData.tabList);

    // Has tab name (sent first msg) => Need confirm to close
    if(tab.id.includes(Constant.TAB_PANEL_TYPE.NEW_TAB_CHAT_AI) && tab.tabNameChatAI) {
        setIsConfirmDeleteTabChat({tabId: tab.id, chatThreadId: tab?.chatThreadId});
        event.stopPropagation();
        return;
    }

    let isCloseTab = false;    
    if (indexNeedCloseTab !== panelData.activeTab) {
        
        isCloseTab = true; 
        removePanelInitData(panelData.id, tab.id, argsAll.panelInitData, argsAll.setPanelInitData);
    } else {
        if (
            (
                panelData.type === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL ||
                panelData.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL ||
                panelData.type === Constant.PANEL_TYPE.SYSTEM_MANAGEMENT ||
                panelData.type === Constant.PANEL_TYPE.PROJECT_MANAGEMENT ||
                panelData.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL
            ) &&
            (
                Utils.getPrefixOfId(tab.id) === 'req' ||
                Utils.getPrefixOfId(tab.id) === 'task' ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.QA_NEW_TICKET_TAB) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.HELPDESK_NEW_TICKET) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_USER_PROFILE) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_ORG_PROFILE) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_MANAGEMENT) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_USER_MANAGEMENT) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_FIELD_MANAGEMENT) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_USER_MANAGEMENT) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.KNOWLEDGE_CREATE_TICKET) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL_CLOSE_TAB) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_CORPORATION_CUSTOMER_MANAGEMENT) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_NORMAL_CONTRACT_DETAIL) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_PUBLIC_KNOWLEDGE_SITE_SETTING) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_SETTING_CHATBOT) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_SETTING_AI) || 
                tab.id.includes(Constant.TAB_PANEL_TYPE.SYSTEM_PROJECT_PROFILE_MANAGEMENT)
            ) || tab.id.includes('QA_NEW_TICKET_') || tab.id.includes(Constant.TAB_PANEL_TYPE.TAB_DUPLICATE_TICKET) || tab.tabId?.includes(Constant.TAB_PANEL_TYPE.TAB_DUPLICATE_TICKET)
        ) {
            isCloseTab = false;
            setCloseTabIdState(tab.id);
            event.stopPropagation();

            if (
                tab.id.includes(Constant.TAB_PANEL_TYPE.KNOWLEDGE_CREATE_TICKET) ||
                tab.id.includes(Constant.TAB_PANEL_TYPE.TAB_DUPLICATE_TICKET) ||
                tab.tabId?.includes(Constant.TAB_PANEL_TYPE.TAB_DUPLICATE_TICKET) ||
                Utils.getPrefixOfId(tab.id) === 'req' ||
                Utils.getPrefixOfId(tab.id) === 'task'
            ) {
                return;
            }
        } else {
            isCloseTab = true;
            removePanelInitData(panelData.id, tab.id, argsAll.panelInitData, argsAll.setPanelInitData);
        }
    }

    let closeList = [];

    let {
        panelRelatedData,
        indexTabRelated,
        tabRelatedData
    } = getPanelRelated(cloneDeep(argsAll.panelListRecoilState), panelData, tab);
    if (indexTabRelated !== -1) {
        closeList.push({
            panelType: panelRelatedData.type,
            panelId: panelRelatedData.id,
            tabId: tabRelatedData.id
        })
    }

    if (isCloseTab) {
        closeList.push({
            panelType: panelData.type,
            panelId: panelData.id,
            tabId: tab.id
        })
    }

    if (!Utils.isEmptyArray(closeList)) {
        closePanelTab({
            event: event,
            isCloseMulti: true,
            closeList: closeList
        });
    }
}

export const onClickActiveTabChange = (index, argsAll, tabData, panelData) => {
    let lastPanel = getPanelAndTabBeforeChangeTab(argsAll);
    if (lastPanel && lastPanel.panelId && lastPanel.tabId) {
        argsAll.setLastActivePanelId(lastPanel);
    }
    
    let panelList = cloneDeep(argsAll.panelListRecoilState);
    let { 
        indexPanelRelated,
        indexTabRelated,
    } = getPanelRelated(panelList, panelData, tabData);

    if(indexTabRelated !== -1) {
        panelList[indexPanelRelated].activeTab = indexTabRelated;
    }

    let currentPanelIndex = panelList.findIndex(panel => panel.type === argsAll.panelData.type);
    if (currentPanelIndex !== -1) {
        panelList[currentPanelIndex].activeTab = index;
        argsAll.setPanelListRecoilState(panelList);
    }
    
    argsAll.handleClose();
};

export const getPanelRelated = (panelList, currentPanelData, currentTabData) => {
    let indexPanelRelated = -1;
    let panelRelatedData = {};
    let indexTabRelated = -1;
    let tabRelatedData = {};
    switch (currentPanelData.type) {
        case Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL:
            indexPanelRelated = panelList.findIndex(
                p => p.type === Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD
            );
            break;
        case Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD:
            indexPanelRelated = panelList.findIndex(
                p => p.type === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
            );
            break;
        case Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL:
            indexPanelRelated = panelList.findIndex(
                p => p.type === Constant.PANEL_TYPE.HELPDESK_CHATTHREAD
            );
            break;
        case Constant.PANEL_TYPE.HELPDESK_CHATTHREAD:
            indexPanelRelated = panelList.findIndex(
                p => p.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
            );
            break;
        case Constant.PANEL_TYPE.PROJECT_MANAGEMENT:
            indexPanelRelated = panelList.findIndex(
                p => p.type === Constant.PANEL_TYPE.PREVIEW_CHATBOT
            );
            break;
        case Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL:
            indexPanelRelated = panelList.findIndex(
                p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_UPLOAD_CSV
            );
            break;
        default:
            break;
    }

    if (indexPanelRelated !== -1) {
        panelRelatedData = panelList[indexPanelRelated];
        if (!Utils.isEmptyObject(panelRelatedData) && currentTabData) {
            let tabList = panelRelatedData.tabList;
            indexTabRelated = tabList.findIndex(t => t.id === currentTabData.id);
            tabRelatedData = tabList[indexTabRelated];
        }
    }

    return { 
        indexPanelRelated,
        panelRelatedData,
        indexTabRelated,
        tabRelatedData
    }
}

export const handleTabChange = (index, argsAll, element, nodeListView, value) => {
    argsAll.updatePanel({
        activeTab: index,
        panelType: argsAll.panelData.type
    });
    argsAll.handleClose();

    let containerRect = element.getBoundingClientRect();
    let posElem = [];
    for (let i = 0; i < nodeListView.length; i++) {
        // Gets the amount of pixels currently visible within the container
        let visiblePageWidth = getVisibleWidth(nodeListView[i], argsAll.panelData);
        posElem.push({ pos: visiblePageWidth });
    }

    let currentIndexs = value;
    let nextIndex = index;

    let isRightPosItem = nextIndex - currentIndexs > 0 ? true : false;

    if (isRightPosItem) {
        if (posElem[nextIndex].pos.left + posElem[nextIndex].pos.width > containerRect.width) {
            element.scrollLeft +=
                posElem[nextIndex].pos.width -
                (containerRect.width - posElem[nextIndex].pos.left);
        }
    } else {
        if (posElem[nextIndex].pos.left + posElem[nextIndex].pos.width <= containerRect.width) {
            element.scrollLeft += posElem[nextIndex].pos.left;
        }
    }
};

let timeoutEvent;
export const onWheel = (event, element, nodeListView, argsAll) => {
    element.scrollLeft +=
        event.deltaY > 0 ? Constant.SCROLL_LEFT_CHANGE : Constant.SCROLL_LEFT_CHANGE * -1;
    event.stopPropagation();

    let containerRect = element.getBoundingClientRect();

    let posElem = [];
    for (let i = 0; i < nodeListView.length; i++) {
        // Gets the amount of pixels currently visible within the container
        let visiblePageWidth = getVisibleWidth(nodeListView[i], argsAll.panelData);
        posElem.push({ pos: visiblePageWidth });
    }

    // trigger wheel end
    if (timeoutEvent) clearTimeout(timeoutEvent);
    timeoutEvent = setTimeout(() => {
        for (let i = 0; i < posElem.length; i++) {
            let item = posElem[i];
            if (item.pos.left + item.pos.width >= item.pos.width * Constant.LIST_VIEW_TAB) {
                element.scrollLeft += item.pos.width - (containerRect.width - item.pos.left);
                break;
            }
        }
    }, Constant.TRIGGER_TIMEOUT_WHEEL_END);
};

export const onTouchEnd = (event, element, nodeListView, argsAll) => {
    let containerRect = element.getBoundingClientRect();
    let posElem = [];
    for (let i = 0; i < nodeListView.length; i++) {
        // Gets the amount of pixels currently visible within the container
        let visiblePageWidth = getVisibleWidth(nodeListView[i], argsAll.panelData);
        posElem.push({ pos: visiblePageWidth });
    }

    for (let i = 0; i < posElem.length; i++) {
        let item = posElem[i];
        if (item.pos.left + item.pos.width >= item.pos.width * Constant.LIST_VIEW_TAB) {
            element.scrollLeft += item.pos.width - (containerRect.width - item.pos.left);
            break;
        }
    }
};


export const getPanelAndTabBeforeChangeTab = (argsAll) => {
    let panelData = argsAll.panelData;
    if (!panelData || Utils.isEmptyObject(panelData) || !panelData.tabList || Utils.isEmptyArray(panelData.tabList)) return;
    let panelId = panelData.id;
    let tabData = panelData.tabList[panelData.activeTab];
    let tabId = tabData?.id;

    return {
        panelId,
        tabId
    }
}


/**
 * updatePanelInitData
 * @param {*} panelId 
 * @param {*} tabId 
 * @param {*} panelInitData 
 * @param {*} setPanelInitData 
 * @param {*} dataKey 
 * @param {*} dataValue 
 */
export const updatePanelInitData = (panelId, tabId, panelInitData, setPanelInitData, dataKey, dataValue) => {
    if (!panelId || !tabId || !setPanelInitData || !dataKey || Utils.isEmpty(dataValue)) return;
    panelId = panelId.toString();
    tabId = tabId.toString();
    let currentPanelInitData = cloneDeep(getRecoil(panelInitDataAtom));
    // let currentPanelInitData = cloneDeep(panelInitData);
    currentPanelInitData = !Utils.isEmptyArray(currentPanelInitData) ? currentPanelInitData : [];
    let initPanelTabData = [
        {
            id: panelId,
            tabList: [
                {
                    id: tabId,
                    data: {}
                }
            ]
        }
    ]
    initPanelTabData[0].tabList[0].data[dataKey] = dataValue;


    if (!Utils.isEmptyArray(currentPanelInitData)) {
        let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelInitData);
        if (currentPanelIndex !== -1) {
            let currentPanel = currentPanelInitData[currentPanelIndex];
            if (!Utils.isEmptyArray(currentPanel.tabList)) {
                let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
                if (currentTabIndex !== -1) {
                    currentPanelInitData[currentPanelIndex].tabList[currentTabIndex].data[dataKey] = dataValue;
                } else {
                    let initTabData = {
                        id: tabId,
                        data: {}
                    }
                    initTabData.data[dataKey] = dataValue;
                    currentPanelInitData[currentPanelIndex].tabList.push(initTabData);
                }
            } else {
                currentPanelInitData[currentPanelIndex].tabList = [
                    {
                        id: tabId,
                        data: {}
                    }
                ]
                currentPanelInitData[currentPanelIndex].tabList[0].data[dataKey] = dataValue;
            }
        } else {
            currentPanelInitData.push(initPanelTabData[0]);
        }
    } else {
        currentPanelInitData = initPanelTabData;
    }
    setPanelInitData(currentPanelInitData);
}


/**
 * removePanelInitData
 * @param {*} panelId 
 * @param {*} tabId 
 * @param {*} panelInitData 
 * @param {*} setPanelInitData 
 * @returns 
 */
export const removePanelInitData = (panelId, tabId, panelInitData, setPanelInitData) => {
    if (!panelId) return;

    let currentPanelInitData = cloneDeep(panelInitData);
    currentPanelInitData = !Utils.isEmptyArray(currentPanelInitData) ? currentPanelInitData : [];

    if (tabId) {
        if (!Utils.isEmptyArray(currentPanelInitData)) {
            let currentPanelIndex = Utils.findIndexInArrayById(panelId, currentPanelInitData);
            if (currentPanelIndex !== -1) {
                let currentPanel = currentPanelInitData[currentPanelIndex];
                if (!Utils.isEmptyArray(currentPanel.tabList)) {
                    let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
                    if (currentTabIndex !== -1) {
                        let currentTabList = currentPanelInitData[currentPanelIndex].tabList;
                        let newTabList = currentTabList.filter(tab => tab.id !== tabId);
                        currentPanelInitData[currentPanelIndex].tabList = newTabList;
                    }
                }
            }
        }
    } else {
        currentPanelInitData = currentPanelInitData.filter(panel => panel.id !== panelId);
    }
    
    setPanelInitData(currentPanelInitData);
}


/**
 * getPanelInitData
 * @param {*} panelId 
 * @param {*} tabId 
 * @param {*} panelInitData 
 * @returns 
 */
export const getPanelInitData = (panelId, tabId, panelInitData) => {
    if (!panelId) return;
    let initData = {};
    
    if (tabId) {
        if (!Utils.isEmptyArray(panelInitData)) {
            let currentPanelIndex = Utils.findIndexInArrayById(panelId, panelInitData);
            if (currentPanelIndex !== -1) {
                let currentPanel = panelInitData[currentPanelIndex];
                let currentTabIndex = Utils.findIndexInArrayById(tabId, currentPanel.tabList);
                if (currentTabIndex !== -1) {
                    let currentTabList = panelInitData[currentPanelIndex].tabList;
                    initData = currentTabList[currentTabIndex].data;
                }
            }
        }
    }
    return initData;
}

/**
 * getAllTabPanelInitData
 * @param {*} panelId 
 * @param {*} panelInitData 
 */
export const getAllTabPanelInitData = (panelId, panelInitData) => {
    if (!Utils.isEmptyArray(panelInitData)) {
        let currentPanelIndex = Utils.findIndexInArrayById(panelId, panelInitData);
        if (currentPanelIndex !== -1) {
            return panelInitData[currentPanelIndex];
        }
    }

    return {};
}

export const calculatePanelWidth = (screenWidth, sideBarWidth, panelSize) => {
    let panelWidth;
    const panelContainerWidth = screenWidth - sideBarWidth;
    if (screenWidth >= Constant.PANEL_RESPONSIVE.PC) {
        switch (panelSize) {
            case Constant.PANEL_SIZE.SIZE_1:
                panelWidth = (panelContainerWidth / 3);
                break;
            case Constant.PANEL_SIZE.SIZE_2:
                panelWidth = ((panelContainerWidth / 3) * 2);
                break;
            case Constant.PANEL_SIZE.SIZE_3:
                panelWidth = panelContainerWidth;
                break;
            default:
                break;
        }

    } else if (screenWidth >= Constant.PANEL_RESPONSIVE.MOBILE && screenWidth < Constant.PANEL_RESPONSIVE.PC) {
        panelWidth = (panelContainerWidth / 2);
    } else {
        panelWidth = screenWidth;
    }

    return panelWidth;
}

export const calculatePanelMargin = (panelSize, nextPanel, panelContainerWidth) => {
    if (!nextPanel) return 0;
    
    let marginRight = 0;
    switch (panelSize) {
        case Constant.PANEL_SIZE.SIZE_1:
            if (nextPanel && nextPanel.size === Constant.PANEL_SIZE.SIZE_3) {
                marginRight = (panelContainerWidth / 3) * 2;
            }
            break;
        case Constant.PANEL_SIZE.SIZE_2:
            if (nextPanel && nextPanel.size !== Constant.PANEL_SIZE.SIZE_1) {
                marginRight = panelContainerWidth / 3;
            }
            break;
        case Constant.PANEL_SIZE.SIZE_3:
            if (nextPanel) {}

            break;
        default:
            break;
    }

    return marginRight;
}